import { useContext, useEffect, useMemo } from "react";
import { AltaContext } from "../../../../context";

const getUnique = (array, key) => {
  if (array) {
    return array.filter(
      (v, i, a) => a.findIndex((t) => t[key] === v[key]) === i
    );
  }
  return [];
};

const getDependingCategories = (array, key, fields) => {
  if (fields?.categoria) {
    const values = array.filter(
      (categoria) => categoria.categoria === fields.categoria
    );
    return getUnique(values, key).map((value) => ({
      label: value[key],
      value: value[key],
    }));
  }
  return [];
};

export const useOptions = ({ type }) => {
  const {
    comboOptions,
    situacion,
    removeDependencies,
    titulares,
    currentTitular,
  } = useContext(AltaContext);
  const uniqueCategories = getUnique(comboOptions.categorias, "categoria");

  const filterByType = () => {
    return uniqueCategories.filter((option) => option.parentesco === type);
  };

  const categoriaOptions = (type ? filterByType() : uniqueCategories).map(
    (category) => ({
      label: category.categoria,
      value: category.categoria,
    })
  );

  const removeDuplicates = (arr) => {
    const seen = new Set();
    return arr.filter((item) => {
      const key = item.value;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const buildOptions = (key) => {
    const dependencies = getDependingCategories(
      comboOptions.categorias,
      key,
      situacion
    );
    if (dependencies.length > 0) return removeDuplicates(dependencies);

    const fallback = uniqueCategories.map((category) => ({
      label: category[key],
      value: category[key],
    }));
    return removeDuplicates(fallback);
  };

  const reglaOptions = useMemo(
    () => buildOptions("regla"),
    [comboOptions.categorias, situacion, uniqueCategories] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const tReglaOptions = useMemo(
    () => buildOptions("tipoRegla"),
    [comboOptions.categorias, situacion, uniqueCategories] // eslint-disable-line react-hooks/exhaustive-deps
  );
  const agrupadoresOptions = comboOptions.agrupadores.map((agrupador) => ({
    label: agrupador.cdagrupa + " - " + agrupador.nombre,
    value: agrupador.cdagrupa,
  }));
  const asociadoOptions =
    titulares?.filter((titular) => titular.familiares < 9) || [];
  const sexOptions = [
    { label: "Hombre", value: "H" },
    { label: "Mujer", value: "M" },
  ];
  const relationOptions = [
    { label: "Hijo", value: "H" },
    { label: "Conyugue", value: "C" },
    // { label: "Otros", value: "O" },
  ];

  const relationOptions902 = [
    { label: "Hijo", value: "H" },
    { label: "Conyuge", value: "C" },
    { label: "Hermanos", value: "D" },
    { label: "Padres", value: "A" },
    { label: "Titular", value: "T" },
    // { label: "Otros", value: "O" },
  ];

  const reglaBOptions = useMemo(
    () => getDependingCategories(comboOptions.categorias, "regla", situacion),
    [comboOptions, situacion]
  );
  const tReglaBOptions = useMemo(
    () => getDependingCategories(comboOptions.categorias, "tregla", situacion),
    [comboOptions, situacion]
  );
  if (!currentTitular) relationOptions.push({ label: "Titular", value: "T" });
  // eslint-disable-next-line
  useEffect(() => !type && removeDependencies(), [situacion?.categoria]);
  return {
    sexOptions,
    relationOptions,
    agrupadoresOptions,
    categoriaOptions,
    reglaOptions,
    tReglaOptions,
    asociadoOptions,
    reglaBOptions,
    tReglaBOptions,
    relationOptions902,
  };
};
